'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Twitter;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
function Twitter(props = {}) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, ...props, children: (0, jsx_runtime_1.jsx)("svg", { viewBox: "0 0 512 512", children: (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" }) }) }));
}
